import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../common/GridLayout";
import { handleDataGridExport } from "../../common/Utils";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';

import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
    Lookup
} from "devextreme-react/data-grid";
import { buildDxFilters, FillFilters,FormatPhoneNumber, loadLookupFromStaticDataSource } from '../../common/Utils'
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import { SearchLayout } from './Layout';
import '../../common/css/searchPage.css';
import { IM, WM } from '../../const/constants';
import { TaskQueueType, TaskState, TaskType } from '../../const/Lookup';
import { set } from 'lodash';
import { MESSAGES } from '../../common/Messages';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const LocationDataEntryList = (props) => {
    const dataGrid = useRef(null);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const allowedPageSizes = [10, 20, 100, 500, 1000];
    const gridKey = "6053706A-F1C4-46F8-924C-A683695483EE";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);

    const initialFormFields = {
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        TaskType: null,
        State: null,
        OwnerId: null,
        Reference: null,
        Settings: null,
        SourceTableName: null,
        RSourceId: null,
        DataEventType: null,
        RAbTaskProcessor: null,
        ProcessingStartDt: null,
        ProcessingEndDt: null,
        ProcessingResultCode: null,
        ProcessingResultInfo: null,
        ArchiveDt: null,
        TaskQueueType: TaskQueueType[0].key
    };
    const FormFieldsTypes = {
        CreationDateTime: 'datetime',
        CreationUserId: 'text',
        LastUpdateDateTime: 'datetime',
        LastUpdateUserId: 'text',
        TaskType: 'lookup',
        State: 'lookup',
        OwnerId: 'text',
        Reference: 'text',
        Settings: 'text',
        SourceTableName: 'text',
        RSourceId: 'text',
        DataEventType: 'text',
        RAbTaskProcessor: 'text',
        ProcessingStartDt: 'datetime',
        ProcessingEndDt: 'datetime',
        ProcessingResultCode: 'text',
        ProcessingResultInfo: 'text',
        ArchiveDt: 'datetime',
        TaskQueueType: 'lookup'
    };
    const [formFields, setformFields] = useState(initialFormFields);

    const handleFormLoad = useCallback(() => {
        loadLookupFromStaticDataSource("TaskQueueType", TaskQueueType, formFields, formRefs);
        loadLookupFromStaticDataSource("TaskType", TaskType, formFields, formRefs);
        loadLookupFromStaticDataSource("State", TaskState, formFields, formRefs);
    }, []);

    const handleSearch = (e) => {
        e.event.stopPropagation();
        loadData(formFields);
    }

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        loadData(initialFormFields);
    }

    useEffect(() => {
        loadData(initialFormFields);
    }, []);
        const deleteRecords = useCallback(() => {
        var deleteUrl = "id/Consignee/DeleteTaskQueue";
        let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${data.TaskQueue.DeleteTaskQueue}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                       
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                    });

            }
        });

    }, [selectedItemKeys]);
    // Handle grid row selection to enable/disable Edit button
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = null;
            setIsEditButtonDisabled(true);
        }
        setSelectedItemKeys(selectedRowsData);
    };
    const loadData = (fields) => {
        const filter = { ...fields };
        if (filter.TaskQueueType === TaskQueueType[0].key) {
            filter.TaskQueueType = null;
        }
        const filters = buildDxFilters(filter,SearchLayout);
        let datasource = loadDatasource();
        datasource.filter(filters);
        setResultData(datasource);
    }
    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.TaskQueue.GetTaskQueue}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);

    const handleValueChanged = (e) => { console.log(e) }

    const handleFieldValueChanged = (name, value, event) => { console.log(name, value, event) }

    const handleSelectedItemChanged = (name, event) => {
        console.log(name, event);
    };
    const handelEditClick = () => {
        let buttonUrl = "";
        history.push(buttonUrl);
    };
    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6 style={{
                                            color: window._env_.Color2
                                        }}>Enter Your Query For Task Queue</h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={() => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='016A87F9-CC19-4877-8069-AC157B83AA78'
                                layoutName='IMCrateDataEntrySearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldValueChanged}
                                handleSelectedItemChange={handleSelectedItemChanged}
                                noSpacingBeforeFirstRow={true}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <ColumnHeaderFilter />
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <Selection mode="multiple" />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column dataType="string" dataField="State" caption="State" cellRender={({ value }) => {
                                const item = TaskState.find((x) => x.key === value);
                                if (!item) return null;
                                return (
                                <div className="flex items-center gap-1">
                                  <i className={`dx-icon-${item.icon}`}></i> {item.value}
                                </div>
                                );
                            }}>
                                <Lookup dataSource={TaskState} valueExpr='key' displayExpr='value' />
                            </Column>
                            <Column dataType="string" dataField="TaskType" caption="Task Type"  >
                                <Lookup dataSource={TaskType} valueExpr='key' displayExpr='value' />
                            </Column>
                            <Column dataType="datetime" dataField="CreationDateTime" caption="Created On" format='MM/dd/yyyy hh:mm:ss a' />
                            <Column dataType="string" dataField="OwnerId" caption="Owner Id" />
                            <Column dataType="string" dataField="Reference" caption="Reference" />
                            <Column dataType="datetime" dataField="ArchiveDt" caption="Archived On" format='MM/dd/yyyy hh:mm:ss a'/>
                            <Column dataType="datetime" dataField="ProcessingStartDt" caption="Processing Start" format='MM/dd/yyyy hh:mm:ss a'/>
                            <Column dataType="datetime" dataField="ProcessingEndDt" caption="Processing End" format='MM/dd/yyyy hh:mm:ss a'/>
                            <Column dataType="string" dataField="ProcessingResultCode" caption="Processing Code" />
                            <Column dataType="string" dataField="ProcessingResultInfo" caption="Processing Info" cssClass="custom-column" allowSorting={false}/>
                             <Column dataType="string" dataField="RowId" caption="Task Id" />
                            <Column dataType="string" dataField="RAbTaskProcessor" caption="Processor Id" />
                            <Column dataType="string" dataField="DataEventType" caption="Data Event Type" />
                            <Column dataType="string" dataField="SourceTableName" caption="Source Table Name" />
                            <Column dataType="string" dataField="RSourceId" caption="Source Record" />
                            <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    onClick={deleteRecords}
                                    text="Delete"
                                    type="default"
                                    disabled={!selectedItemKeys.length}
                                />
                            </GridToolbarItem>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(LocationDataEntryList);